import { ReactNode } from "react";

import BreadCrumb from "shared/BreadCrumb";
import { AppLayout } from "shared/Layout";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations, useI18n } from "utils/with-i18n.utils";
import { fetchSEO, withSeo } from "utils/with-seo.utils";

import { Banner } from "../Banner";

import { Article } from "./Article";

export type PresseProps = Awaited<ReturnType<typeof getStaticProps>>["props"];

export const Presse = () => {
  const i18n = useI18n();

  const AllArticles = [
    {
      title: i18n.t("press.france2Title"),
      img: "/images/seo/presse/france2.webp",
      description: i18n.t("press.france2Description"),
      link: "https://www.francetvinfo.fr/economie/pouvoir-achat/pouvoir-d-achat-l-essor-de-la-location-de-smartphones_6161727.html",
      date: i18n.t("press.france2Date"),
    },
    {
      title: i18n.t("press.parisienTitle"),
      img: "/images/seo/presse/parisien.webp",
      description: i18n.t("press.parisienDescription"),
      link: "https://www.leparisien.fr/economie/consommation/louer-son-smartphone-peut-etre-une-bonne-affaire-face-a-la-flambee-des-prix-02-11-2023-NS7TIS4KV5GVRNK44XLAOB5AGI.php",
      date: i18n.t("press.parisienDate"),
    },
    {
      title: i18n.t("press.challengesTitle"),
      img: "/images/seo/presse/challenge.webp",
      description: i18n.t("press.challengesDescription"),
      link: "https://www.challenges.fr/club-entrepreneurs/mobile-club-la-start-up-qui-veut-democratiser-la-location-de-smartphones_872340",
      date: i18n.t("press.challengesDate"),
    },
    {
      title: i18n.t("press.maddynessTitle"),
      img: "/images/seo/presse/maddyness.webp",
      description: i18n.t("press.maddynessDescription"),
      link: "https://www.maddyness.com/2023/11/02/pourquoi-mobile-club-a-choisi-de-lever-7-millions-deuros-en-dette/",
      date: i18n.t("press.maddynessDate"),
    },
    {
      title: i18n.t("press.figaroTitle"),
      img: "/images/seo/presse/figaro.webp",
      description: i18n.t("press.figaroDescription"),
      link: "https://www.lefigaro.fr/secteur/high-tech/la-location-de-smartphones-en-plein-essor-20230901",
      date: i18n.t("press.figaroDate"),
    },
    {
      title: i18n.t("press.capitalTitle"),
      img: "/images/seo/presse/capital.webp",
      description: i18n.t("press.capitalDescription"),
      link: "https://www.capital.fr/conso/face-a-la-flambee-des-prix-de-plus-en-plus-de-francais-preferent-louer-leur-smartphone-1477970",
      date: i18n.t("press.capitalDate"),
    },
    {
      title: i18n.t("press.bfmTitle"),
      img: "/images/seo/presse/bfm.webp",
      description: i18n.t("press.bfmDescription"),
      link: "https://www.lesechos.fr/start-up/portraits/damien-morin-le-jeune-sage-de-la-french-tech-1895846",
      date: i18n.t("press.bfmDate"),
    },
    {
      title: i18n.t("press.echosTitle"),
      img: "/images/seo/presse/echos.webp",
      description: i18n.t("press.echosDescription"),
      link: "https://www.lesechos.fr/start-up/portraits/damien-morin-le-jeune-sage-de-la-french-tech-1895846",
      date: i18n.t("press.echosDate"),
    },
    {
      title: i18n.t("press.tribuneTitle"),
      img: "/images/seo/presse/tribune.webp",
      description: i18n.t("press.tribuneDescription"),
      link: "https://www.latribune.fr/supplement/louer-son-telephone-la-prochaine-revolution-929044.html",
      date: i18n.t("press.tribuneDate"),
    },
  ];

  return (
    <>
      <div className="mx-auto max-w-[1440px]">
        <BreadCrumb
          parts={[
            { label: i18n.t("breadcrumb.home"), to: "/" },
            {
              label: i18n.t("breadcrumb.press"),
              to: "/presse",
            },
          ]}
        />

        <div className="flex flex-col px-5 xl:px-32">
          <Banner firstLine={i18n.t("press.title")} />

          <div className="flex flex-col gap-8 mb-[60px]">
            {AllArticles.map((article) => {
              return (
                <Article
                  title={article.title}
                  img={article.img}
                  description={article.description}
                  link={article.link}
                  date={article.date}
                  key={article.title}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

Presse.getLayout = (page: ReactNode, pageProps: PresseProps) => (
  <AppLayout withBanner {...pageProps}>
    {page}
  </AppLayout>
);

export const getStaticProps = async () => {
  const translations = await fetchTranslations([
    "marquee",
    "breadcrumb",
    "press",
  ]);

  const seo = await fetchSEO("presse");

  return {
    props: {
      translations,
      seo,
      settings: await fetchSettings(),
    },
  };
};

export default withApp(Presse, [withSeo]);
